import { makeStyles, createStyles } from '@material-ui/core'

export const styles = theme => createStyles({})

export default makeStyles(styles)